import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskServicesRoute: InvariantJiraRoute = {
	name: 'servicedesk-services',
	path: '/jira/servicedesk/projects/:projectKey/services',
	exact: true,
};
